import React from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useI18nContext } from '@procore/core-react';
import { useStyles } from './BusinessProfileActivity.styles';
import { Metrics } from '../../types/metrics-types';
import ActivityTile from './ActivityTile';

interface Props {
  metrics: Metrics;
}

const PaidActivityCard = ({ metrics }: Props) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const displayFirstGrid =
    metrics?.rfisCompleted > 0 || metrics?.submittalsCompleted > 0;
  const displaySecondGrid =
    metrics?.activeProjects > 0 || metrics?.numberOfOpenRfi > 0;
  const smallerMatches = useMediaQuery('(min-width:960px)');

  return (
    <Box data-test-id="paid-account-activity-card">
      {metrics?.totalProjects > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <ActivityTile
            metric={metrics?.totalProjects}
            text={I18n.t(
              `components.metrics.total_procore_projects_${
                metrics?.totalProjects === 1 ? 'singular' : 'plural'
              }`
            )}
          />
        </div>
      )}
      <Grid
        container
        gap={smallerMatches ? 6 : 0}
        direction={smallerMatches ? 'row' : 'column'}
      >
        {displayFirstGrid && (
          <Grid item>
            <Typography className={classes.title}>
              {I18n.t('components.metrics.completed')}
            </Typography>
            <Grid container item className={classes.firstGridTiles}>
              {metrics?.rfisCompleted > 0 && (
                <Grid item>
                  <ActivityTile
                    metric={metrics?.rfisCompleted}
                    text={I18n.t(
                      `components.metrics.rfis_${
                        metrics?.rfisCompleted === 1 ? 'singular' : 'plural'
                      }`
                    )}
                  />
                </Grid>
              )}
              {metrics?.submittalsCompleted > 0 && (
                <Grid item>
                  <ActivityTile
                    metric={metrics?.submittalsCompleted}
                    text={I18n.t(
                      `components.metrics.submittals_${
                        metrics?.submittalsCompleted === 1
                          ? 'singular'
                          : 'plural'
                      }`
                    )}
                  />
                </Grid>
              )}
            </Grid>
            {metrics?.totalProjects > 0 && (
              <Typography className={classes.activeProcoreProjects}>
                {`${I18n.t('components.metrics.on')} ${
                  metrics?.totalProjects
                } ${I18n.t(
                  `components.metrics.procore_projects_${
                    metrics?.totalProjects === 1 ? 'singular' : 'plural'
                  }`
                )}`}
              </Typography>
            )}
          </Grid>
        )}
        {displaySecondGrid && (
          <Grid item xs="auto">
            <Typography className={classes.title}>
              {I18n.t('components.metrics.current_activity')}
            </Typography>
            <Grid
              container
              item
              direction={smallerMatches ? 'row' : 'column'}
              className={classes.secondeGridTiles}
            >
              {metrics?.activeProjects > 0 && (
                <Grid item xs="auto">
                  <ActivityTile
                    metric={metrics?.activeProjects}
                    text={I18n.t(
                      `components.metrics.active_projects_${
                        metrics?.activeProjects === 1 ? 'singular' : 'plural'
                      }`
                    )}
                  />
                </Grid>
              )}
              {metrics?.numberOfOpenRfi > 0 && (
                <Grid item xs="auto">
                  <ActivityTile
                    metric={metrics?.numberOfOpenRfi}
                    text={I18n.t(
                      `components.metrics.open_rfis_${
                        metrics?.numberOfOpenRfi === 1 ? 'singular' : 'plural'
                      }`
                    )}
                  />
                </Grid>
              )}
              {metrics?.averageTimeToSubmittal > 0 && (
                <Grid item xs="auto">
                  <ActivityTile
                    metric={metrics?.averageTimeToSubmittal}
                    text={I18n.t(
                      `components.metrics.average_time_to_submittal_${
                        metrics?.averageTimeToSubmittal === 1
                          ? 'singular'
                          : 'plural'
                      }`
                    )}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PaidActivityCard;
